import * as todos from '../../constants/todos'
import Axios from 'axios'

const addTodoRequest = () => {
    return {
        type: todos.TODOS_ADD_TODO_REQUEST
    }
}

const addTodoRequestSuccess = () => {
    return {
        type: todos.TODOS_ADD_TODO_SUCCESS
    }
}

const addTodoRequestError = () => {
    return {
        type: todos.TODOS_ADD_TODO_ERROR
    }
}

export const addTodo = obj => async dispatch => {
    dispatch(addTodoRequest())
    try {
        await Axios.put('/api/todos/AddTodo', obj)
        dispatch(addTodoRequestSuccess())
        dispatch(fetchTodos())
    } catch (error) {
        dispatch(addTodoRequestError())
    }
}

export const fetchTodos = () => async dispatch => {
    try {
        const response = await Axios.get(`/api/todos/all`)
        const data = response.data
        dispatch(fetchTodosSuccess({ fetchedTodos: data }))
    } catch (err) {
        console.log(err)
    }
}

const fetchTodosSuccess = ({ fetchedTodos }) => {
    return {
        type: todos.TODOS_FETCH_TODOS,
        payload: { todos: fetchedTodos.todos, showDone: fetchedTodos.showDone }
    }
}

const fetchTodoSuccess = ({ todo }) => {
    return {
        type: todos.TODOS_FETCH_TODO,
        payload: { todo }
    }
}

export const fetchTodo = id => async dispatch => {
    try {
        const response = await Axios.get(`/api/todos/one/${id}`)
        dispatch(fetchTodoSuccess({ todo: response.data }))
    } catch (error) {
        console.log(error)
    }
}

export const addTodoModalCancel = () => {
    return {
        type: todos.TODOS_ADD_TODO_MODAL_CANCEL
    }
}

export const addTodoModalOpen = (params) => {
    let kategoria, linkAddress, linkTitle
    if (params !== undefined) {
        ({ kategoria, linkAddress, linkTitle } = params)
    }
    return {
        type: todos.TODOS_ADD_TODO_MODAL_OPEN,
        payload: { kategoria, linkAddress, linkTitle }
    }
}

export const toggleTodoList = () => {
    return {
        type: todos.TODOS_TOGGLE_LIST
    }
}

export const closeTodoList = () => {
    return {
        type: todos.TODOS_CLOSE_LIST
    }
}

export const toggleTodo = (field, _id) => async dispatch => {
    try {
        await Axios.post(`/api/todos/toggleTodo`, { field: field, _id: _id })
        dispatch(fetchTodos())
    } catch (error) {
        console.log(error)
    }
}

export const toggleShowDone = () => async dispatch => {
    try {
        await Axios.post(`/api/todos/toggleShowDone`)
        dispatch(fetchTodos())
    } catch (error) {
        console.log(error)
    }
}